import React, { useEffect, useRef } from "react";

function SvgLine({ labels, series, color = "#c6272a" }) {
  const width = 640;
  const height = 240;
  const padding = 28;
  const max = Math.max(...series, 1);
  const points = series.map((value, index) => {
    const x = padding + (index * (width - padding * 2)) / Math.max(series.length - 1, 1);
    const y = height - padding - (value / max) * (height - padding * 2);
    return `${x},${y}`;
  }).join(" ");

  return (
    <svg viewBox={`0 0 ${width} ${height}`} className="w-100" style={{ minHeight: 240 }}>
      <polyline fill="none" stroke={color} strokeWidth="3" points={points} />
      {series.map((value, index) => {
        const x = padding + (index * (width - padding * 2)) / Math.max(series.length - 1, 1);
        const y = height - padding - (value / max) * (height - padding * 2);
        return <circle key={`${labels[index]}-${index}`} cx={x} cy={y} r="4" fill={color} />;
      })}
    </svg>
  );
}

export default function ApexChart({ type = "area", height = 280, options }) {
  const ref = useRef(null);

  useEffect(() => {
    const ApexCharts = window.ApexCharts;
    if (!ApexCharts || !ref.current) {
      return undefined;
    }

    const chart = new ApexCharts(ref.current, {
      ...options,
      chart: {
        type,
        height,
        toolbar: { show: false },
        zoom: { enabled: false },
        ...(options.chart || {}),
      },
    });

    chart.render();
    return () => {
      chart.destroy();
    };
  }, [type, height, options]);

  if (typeof window === "undefined" || !window.ApexCharts) {
    const series = options?.series?.[0]?.data || [];
    const labels = options?.xaxis?.categories || series.map((_, index) => index + 1);
    return <SvgLine labels={labels} series={series.map((value) => Number(value) || 0)} />;
  }

  return <div ref={ref} />;
}
